import { ReactNode, useState } from 'react'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { GlobalFilterBar } from '../GlobalFilterBar'
import styles from './Layout.module.css'

interface LayoutProps {
  children: ReactNode
}

export function Layout({ children }: LayoutProps) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed)
  }

  return (
    <div className={styles.layout}>
      <Sidebar collapsed={sidebarCollapsed} onToggle={toggleSidebar} />
      <div className={`${styles.main} ${sidebarCollapsed ? styles.mainExpanded : ''}`}>
        <Header onMenuClick={toggleSidebar} />
        <GlobalFilterBar />
        <main className={styles.content}>
          {children}
        </main>
      </div>
    </div>
  )
}
